import React, { createContext, useContext } from 'react';
import type { Product } from '../data/products';

export interface StoreBootstrap {
  version: 1;
  buildId?: string;
  url: string;
  products?: Product[];
  homepageSettings?: Record<string, boolean>;
  felgusEnabled?: boolean;
  categories?: any[];
  categoryRows?: Record<string, Product[]>;
  maintenance?: { maintenance_mode: boolean; maintenance_message: string };
  page?: { kind: string; data: any };
}

const Context = createContext<StoreBootstrap | null>(null);
export const StoreBootstrapProvider = Context.Provider;
export const useStoreBootstrap = () => useContext(Context);
export function useStoreUrl() {
  const bootstrap = useStoreBootstrap();
  const href = typeof window !== 'undefined' ? window.location.href : bootstrap?.url || '/';
  return new URL(href, 'https://felgocar.pl');
}
export function usePageBootstrap(kind: string) {
  const bootstrap = useStoreBootstrap();
  const url = useStoreUrl();
  return bootstrap?.page?.kind === kind && new URL(bootstrap.url, url.origin).pathname === url.pathname
    ? bootstrap.page.data : undefined;
}
